import React, { Component } from 'react';
import ChangeTable from './components/ChangeTable';
import { translate } from 'react-i18next';
import swal from 'sweetalert';

import $ from 'jquery';
window.$ = window.jQuery = require("jquery");
require('ms-signalr-client');

var Config = require('../../config');
var _hub;
var ChatProxy;
var ChatUrl = Config.default.apiGateway.short_url + "signalr";
var socket = "";

class ChangeToList extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.increaseCalledTimes = this.increaseCalledTimes.bind(this);

		this.state = {
			list_called: [],
			health_facilities_name:"",
		}
	}

	componentWillMount(){
		this._mounted = true;
		var search = this.props.match.url.replace('/', '');

		//Actualizar listado por mensaje del servidor
      	_hub = $.hubConnection(ChatUrl, {
        	useDefaultPath: false
      	});

      	ChatProxy = _hub.createHubProxy('ChatHub');
      	ChatProxy.getItems = this.getList;

      	ChatProxy.on("addNewMessageToPage", function(name, message) {
	        if(message === "refresh" && search.indexOf('change_list') !== -1){
	          this.getItems();
	        }
      	});

      	_hub.start()
      	.done(function() {
        	console.log("Connected to Signalr Server");
      	})
      	.fail(function() {
        	console.log("failed in connecting to the signalr server");
      	});
      	
      	try{
			socket = new WebSocket("wss://localhost:2019");

		}catch(error){
			console.log('Lector no conectado');
		}
		this.setState({ show: true,showSaveBtn:false,count:0,flagStart:false,flagFinished:false,disableStartBtn:false});

		socket.onerror = (event)=> {
			console.log(event);
		};

		socket.onopen = (event)=> {
		   socket.send("initfp");
		};

		socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);

		    console.log(res);
		}

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'health_facilities/'+this.props.match.params.health_id, {
			method: 'GET',
			headers: new Headers({
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities_name: response.health_facilities.name
				});
			}
		});
	}

	componentWillUnmount(){
		this._mounted = false;
		socket.close();
	}

	getList(){
		fetch(Config.default.apiGateway.URL+
			'caller_actions_history?option=list_called&health_facilities_id='+this.props.match.params.health_id,{
			method : 'get',
			headers: new Headers({
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => res.json())
		.then(response => {
			if(this._mounted){
				var old_donor = "";
				var old_area = "";
				if(this.state.list_called.length >0){
					old_donor = this.state.list_called[0].donor;
					if(this.state.list_called[0].machine_name !==null){
						old_area = this.state.list_called[0].machine_name.split('|')[0];
					}
				}
				this.setState({list_called:response});
				if(response.length > 0){
					setTimeout(function(){
						try{
							if(response[0].machine_name !== null && response[0].called_times ==0){
								if(response[0].donor !== "  "){
									console.log(old_donor+" == "+response[0].donor);
									console.log(old_area+" == "+response[0].machine_name.split('|')[0]);
									if(old_donor !== response[0].donor || old_area !== response[0].machine_name.split('|')[0]){
										console.log(response[0].donor+", pasar a "+response[0].machine_name.split('|')[0]);
										socket.send(response[0].donor+", pasar a "+response[0].machine_name.split('|')[0]);
										this.increaseCalledTimes(response[0].id);
									}
								}else{
									console.log("Ficha numero "+response[0].record_number+", pasar a "+response[0].machine_name.split('|')[0]);
									socket.send("Ficha numero "+response[0].record_number+", pasar a "+response[0].machine_name.split('|')[0]);
									this.increaseCalledTimes(response[0].id);
								}
							}
						}catch{
							swal('Error', "No fue posible conectar con aplicación HAP", 'error');
						}
					}.bind(this), 500);
				}
			}
		})
		
	}

	increaseCalledTimes(caller_id, machine_name){
		fetch(Config.default.apiGateway.URL+'caller_actions_history?id='+caller_id+'&ip=&section=null&option=increase_called_times', {
		  method: 'PUT', // or 'PUT'
		  headers: new Headers({
			'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			'Accept': 'application/json',
			'Content-Type': 'application/json;charset=UTF-8'
		  })
		}).then(res => {
		  if(res.ok){
			return res.json();
		  }console.log(res)})
		.catch(error => console.error('Error:', error))
		.then(response => {
		});
	  }

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12 form-group">
				<fieldset>
					<legend style={{textAlign:"center"}}>
						<h2>{this.state.health_facilities_name}</h2>
					</legend>
					<ChangeTable 
						{...this.props}
						onRef={ref => (this.table_change = ref)}
						list_called={this.state.list_called}
						getList={this.getList}
					/>
				</fieldset>
			</div>
		)
	}
}

export default translate('translations')(ChangeToList);